import React, { Fragment, useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Card, Tab, Nav } from 'react-bootstrap'
import ProviderType from './ProviderType';
import ProviderSpecialite from './ProviderSpecialite';
import TypeActe from './TypeActe';
import FamilleActe from './FamilleActe';
import Acte from './Acte';
import Acteur from './Acteur';
import LettreCle from './LettreCle';
import Tarif from './Tarif';
import TarifMedicament from './TarifMedicament';
import Medicament from './Medicament';
import ActeProduction from './ActeProduction';
import Optique from './Optique';
import ActesControls from './ActesControls';
import ActePrestataire from './ActePrestataire';
import { useTranslation } from "react-i18next";
import { currentUser } from "../../../../store/selectors/CurrentUserSelector";

// Import font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBuilding, 
  faStethoscope, 
  faBan, 
  faIndustry, 
  faCertificate, 
  faPills, 
  faGlasses, 
  faHandHoldingMedical, 
  faFileMedical,
  faClipboardList,
  faFileInvoiceDollar,
  faKey,
  faHospital
} from '@fortawesome/free-solid-svg-icons';

const ParametragePrestataire = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // Define permission functions first
    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser?.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser?.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    const hasAccess = (type) => {
        switch(type){
            case 'type de prestataire':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTPROVIDERTYPE')
            case 'spécialités':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTSPECIALITE')
            case 'acte':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTACTE')
            case 'acte production':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTACTEPROD')
            case 'tarif':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTTARIF')
            case 'tarifmedicament':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTTARIF')
            case 'lettre clé':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTLETTRECLE')
            case 'famille acte':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTFAMILLEACTE')
            case 'grande famille acte':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTGRANFAMACTE')
            case 'médicament':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTMEDICAMENT')
            case 'optique':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'PARAMOPTIQUE')
            case 'controle':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTACTE')
            case 'acteprestataire':
                return hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'LISTACTE')
            default:
                return false
        }
    }

    // Updated tabData with FontAwesome icons
    const tabData = [
        {
            label: t("provider.type"),
            name: "type de prestataire",
            icon: faBuilding,
            content: <ProviderType/>
        },
        {
            label: t("provider.speciality"),
            name: "spécialités",
            icon: faStethoscope,
            content: <ProviderSpecialite/>
        },
        {
            label: t("provider.famTypeActe"),
            name: "grande famille acte",
            icon: faFileMedical,
            content: <FamilleActe/>
        },
        {
            label: t("provider.typeActe"),
            name: "famille acte",
            icon: faClipboardList,
            content: <TypeActe/>
        },
        {
            label: t("provider.acte"),
            name: "acte",
            icon: faHandHoldingMedical,
            content: <Acte/>
        },
        {
            label: t("provider.acteProd"),
            name: "acte production",
            icon: faFileInvoiceDollar,
            content: <ActeProduction/>
        },
        {
            label: t("provider.tarif"),
            name: "tarif",
            icon: faCertificate,
            content: <Tarif/>
        },
        {
            label: "Tarif médicaments",
            name: "tarifmedicament",
            icon: faFileInvoiceDollar,
            content: <TarifMedicament/>
        },
        {
            label: t("provider.lettreCle"),
            name: "lettre clé",
            icon: faKey,
            content: <LettreCle/>
        },
        {
            label: t("provider.drug"),
            name: "médicament",
            icon: faPills,
            content: <Medicament/>
        },
        {
            label: t("provider.optic"),
            name: "optique",
            icon: faGlasses,
            content: <Optique/>
        },
        {
            label: 'Contrôles Actes',
            name: "controle",
            icon: faClipboardList,
            content: <ActesControls/>
        },
        {
            label: t("common.act-provider"),
            name: "actePrestataire",
            icon: faHospital,
            content: <ActePrestataire/>
        }
    ]

    // Function to get initial active tab from URL hash or default to first accessible tab
    const getInitialActiveTab = () => {
        // Check if currentUser exists first
        if (!props.currentUser) {
            return tabData[0]?.name.toLowerCase() || '';
        }

        const hash = window.location.hash.substring(1); // Remove the '#' character
        if (hash) {
            // Check if the hash corresponds to a valid tab and user has access
            const foundTab = tabData.find(tab => tab.name.toLowerCase() === hash.toLowerCase());
            if (foundTab && hasAccess(foundTab.name.toLowerCase())) {
                return hash.toLowerCase();
            }
        }
        // Return first accessible tab as default
        const firstAccessibleTab = tabData.find(tab => hasAccess(tab.name.toLowerCase()));
        return firstAccessibleTab ? firstAccessibleTab.name.toLowerCase() : tabData[0]?.name.toLowerCase() || '';
    };

    const [activeKey, setActiveKey] = useState(() => getInitialActiveTab());

    // Update URL hash when tab changes
    const handleTabSelect = (selectedKey) => {
        setActiveKey(selectedKey);
        if (selectedKey) {
            window.location.hash = selectedKey;
        }
    };

    // Listen for hash changes (back/forward browser navigation)
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.substring(1);
            if (hash && props.currentUser) {
                const foundTab = tabData.find(tab => tab.name.toLowerCase() === hash.toLowerCase());
                if (foundTab && hasAccess(foundTab.name.toLowerCase())) {
                    setActiveKey(hash.toLowerCase());
                }
            }
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, [props.currentUser]); // Add props.currentUser as dependency

    // Update activeKey when currentUser changes
    useEffect(() => {
        if (props.currentUser && !activeKey) {
            setActiveKey(getInitialActiveTab());
        }
    }, [props.currentUser]);

    // Set initial hash if none exists
    useEffect(() => {
        if (activeKey && !window.location.hash) {
            window.location.hash = activeKey;
        }
    }, [activeKey]);

    // Early return if no currentUser
    if (!props.currentUser) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{height: '300px'}}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <Row>
                <Col xl={12}>
                    <Card className="shadow-sm border-0">
                        <Card.Header className="bg-white border-bottom">
                            <Card.Title className="text-primary mb-0">
                                <FontAwesomeIcon icon={faHospital} className="me-2" />
                                {t('provider.parameter')}
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {/* Nav tabs */}
                            <div className='custom-tab-1'>
                                <Tab.Container activeKey={activeKey} onSelect={handleTabSelect}>
                                    <Nav as='ul' className='nav-tabs nav-tabs-custom'>
                                        {tabData.map((data, i) => (
                                            <Nav.Item as='li' key={i}>
                                                <Nav.Link 
                                                    disabled={!hasAccess(data.name.toLowerCase())} 
                                                    eventKey={data.name.toLowerCase()}
                                                    href={`#${data.name.toLowerCase()}`}
                                                    className="d-flex align-items-center"
                                                >
                                                    <FontAwesomeIcon icon={data.icon} className="me-2" />
                                                    {data.label}
                                                </Nav.Link>
                                            </Nav.Item>
                                        ))}
                                    </Nav>
                                    <Tab.Content className='pt-4'>
                                        {tabData.map((data, i) => (
                                            <Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
                                                <div>{data.content}</div>
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        errorMessage: state.admin.errorMessage,
        successMessage: state.admin.successMessage,
        showLoading: state.admin.showLoading,
        admin: state.admin.administration,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(ParametragePrestataire);